module.exports = "//static.hsappstatic.net/LoginUI/static-1.8157/img/hubspotMobileApp.png"